import { makeAutoObservable } from 'mobx'
import { IntegrationsStore } from './IntegrationsStore'
import { FbeAuthStore } from './FbeAuthStore'

export class AppRootStore {
  integrationsStore: IntegrationsStore
  fbeAuthStore: FbeAuthStore
  constructor() {
    makeAutoObservable(this)
    this.asyncConstructor()
    this.integrationsStore = new IntegrationsStore()
    this.fbeAuthStore = new FbeAuthStore()
  }

  getIntegrationsStore = () => this.integrationsStore
  getFbeAuthStore = () => this.fbeAuthStore
  private getFbExchangeCode = () => new URLSearchParams(window.location.search).get('code')
  private getFbStateParam = () => new URLSearchParams(window.location.search).get('state')
  private getFbErrorParam = () => new URLSearchParams(window.location.search).get('error')
  private handleFbParams = async () => {
    const code = this.getFbExchangeCode()
    const state = this.getFbStateParam()
    const error = this.getFbErrorParam()
    if (code && state && window.opener && window.opener.processFbCallBack) {
      await window.opener.processFbCallBack(code, state)
    } else if (error) {
      window.close()
    }
  }

  private asyncConstructor = async () => {
    await this.handleFbParams()
  }
}

export const appRootStore = new AppRootStore()
